import * as React from 'react';
import './Loader.scss';

interface Props {
  small?: boolean;
}

export default class Loader extends React.Component<Props> {
  render() {
    return <span className={'loader' + (this.props.small ? ' small' : '')} role="loader"/>;
  }
}
